/* RESPONSIBLE TEAM: team-integration-apps */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class AccountList extends Fragment {
  @attr('string') listId;
}
